module.exports = __webpack_public_path__ + "images/buttons/btn-appstore-2.2928664fe1fc6aca8858.svg";